import { Inject, Injectable, Injector }from '@angular/core';


import { Reports_custom_ds_count_tasks_details_report_flowService } from './Reports.datasource.index';
import { Reports_custom_ds_count_tasks_report_flowService } from './Reports.datasource.index';
import { Reports_custom_ds_cycle_countService } from './Reports.datasource.index';
import { Reports_custom_ds_get_billing_tasks_by_idsService } from './Reports.datasource.index';
import { Reports_custom_ds_get_count_tasks_by_chainHeadsService } from './Reports.datasource.index';
import { Reports_custom_ds_get_distincit_pallet_countService } from './Reports.datasource.index';
import { Reports_custom_ds_get_first_warehouseService } from './Reports.datasource.index';
import { Reports_custom_ds_get_first_warehouse_address_by_invoiceIdService } from './Reports.datasource.index';
import { Reports_custom_ds_get_flow_order_data_blno_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_get_flow_order_data_rnno_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_get_inbound_licenseplate_attachmentService } from './Reports.datasource.index';
import { Reports_custom_ds_get_inbound_lp_detailsService } from './Reports.datasource.index';
import { Reports_custom_ds_get_inbound_lp_details_flowService } from './Reports.datasource.index';
import { Reports_custom_ds_get_invoice_header_by_invoiceIdService } from './Reports.datasource.index';
import { Reports_custom_ds_get_invoice_line_details_by_invoiceId_neService } from './Reports.datasource.index';
import { Reports_custom_ds_get_invoice_lines_for_report_by_invoiceIdService } from './Reports.datasource.index';
import { Reports_custom_ds_get_lp_contentsService } from './Reports.datasource.index';
import { Reports_custom_ds_get_material_packaging_weightService } from './Reports.datasource.index';
import { Reports_custom_ds_get_order_by_order_id_rptService } from './Reports.datasource.index';
import { Reports_custom_ds_get_order_data_blno_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_get_order_data_rnno_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_get_order_signature_attachmentService } from './Reports.datasource.index';
import { Reports_custom_ds_get_outbound_first_load_survey_advancedService } from './Reports.datasource.index';
import { Reports_custom_ds_get_outbound_last_load_survey_advancedService } from './Reports.datasource.index';
import { Reports_custom_ds_get_outbound_licenseplate_attachmentService } from './Reports.datasource.index';
import { Reports_custom_ds_get_owner_address_by_invoiceIdService } from './Reports.datasource.index';
import { Reports_custom_ds_get_pallet_detailsService } from './Reports.datasource.index';
import { Reports_custom_ds_get_shipping_pallets_by_order_idService } from './Reports.datasource.index';
import { Reports_custom_ds_get_survey_by_loadcontainer_rptService } from './Reports.datasource.index';
import { Reports_custom_ds_get_surveyoperationcontexttypes_by_name_rptService } from './Reports.datasource.index';
import { Reports_custom_ds_get_warehouse_address_by_warehouseIdService } from './Reports.datasource.index';
import { Reports_custom_ds_inbound_order_audit_report_headerService } from './Reports.datasource.index';
import { Reports_custom_ds_inbound_order_details_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_inbound_order_details_report_auto_emailService } from './Reports.datasource.index';
import { Reports_custom_ds_inbound_order_summary_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_inbound_order_summary_report_auto_emailService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_by_license_plate_dataService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_by_license_plate_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_count_tasksService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_detailService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_detail_dataService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_detail_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_obol_getlicenseplates_orderid_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_details_bill_of_lading_report_advancedService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_header_bill_of_lading_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_order_audit_report_headerService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_order_details_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_order_details_report_auto_emailService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_order_summary_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_outbound_shipment_summary_report_auto_emailService } from './Reports.datasource.index';
import { Reports_custom_ds_pallet_transactions_detailsService } from './Reports.datasource.index';
import { Reports_ds_get_licenseplates_by_inbound_orderIdService } from './Reports.datasource.index';
import { Reports_ds_get_licenseplates_by_shipmentIdService } from './Reports.datasource.index';
import { Reports_ds_get_order_signature_attachmentService } from './Reports.datasource.index';
import { Reports_ds_get_shipment_by_orderId_top1Service } from './Reports.datasource.index';

@Injectable({ providedIn: 'root' })
export class Reports_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public Reports: Reports_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_count_tasks_details_report_flow: Reports_custom_ds_count_tasks_details_report_flowService;
  public get custom_ds_count_tasks_details_report_flow(): Reports_custom_ds_count_tasks_details_report_flowService {
    if(!this._custom_ds_count_tasks_details_report_flow) {
      this._custom_ds_count_tasks_details_report_flow = this.injector.get(Reports_custom_ds_count_tasks_details_report_flowService);
    }
    return this._custom_ds_count_tasks_details_report_flow;
  }
  private _custom_ds_count_tasks_report_flow: Reports_custom_ds_count_tasks_report_flowService;
  public get custom_ds_count_tasks_report_flow(): Reports_custom_ds_count_tasks_report_flowService {
    if(!this._custom_ds_count_tasks_report_flow) {
      this._custom_ds_count_tasks_report_flow = this.injector.get(Reports_custom_ds_count_tasks_report_flowService);
    }
    return this._custom_ds_count_tasks_report_flow;
  }
  private _custom_ds_cycle_count: Reports_custom_ds_cycle_countService;
  public get custom_ds_cycle_count(): Reports_custom_ds_cycle_countService {
    if(!this._custom_ds_cycle_count) {
      this._custom_ds_cycle_count = this.injector.get(Reports_custom_ds_cycle_countService);
    }
    return this._custom_ds_cycle_count;
  }
  private _custom_ds_get_billing_tasks_by_ids: Reports_custom_ds_get_billing_tasks_by_idsService;
  public get custom_ds_get_billing_tasks_by_ids(): Reports_custom_ds_get_billing_tasks_by_idsService {
    if(!this._custom_ds_get_billing_tasks_by_ids) {
      this._custom_ds_get_billing_tasks_by_ids = this.injector.get(Reports_custom_ds_get_billing_tasks_by_idsService);
    }
    return this._custom_ds_get_billing_tasks_by_ids;
  }
  private _custom_ds_get_count_tasks_by_chainHeads: Reports_custom_ds_get_count_tasks_by_chainHeadsService;
  public get custom_ds_get_count_tasks_by_chainHeads(): Reports_custom_ds_get_count_tasks_by_chainHeadsService {
    if(!this._custom_ds_get_count_tasks_by_chainHeads) {
      this._custom_ds_get_count_tasks_by_chainHeads = this.injector.get(Reports_custom_ds_get_count_tasks_by_chainHeadsService);
    }
    return this._custom_ds_get_count_tasks_by_chainHeads;
  }
  private _custom_ds_get_distincit_pallet_count: Reports_custom_ds_get_distincit_pallet_countService;
  public get custom_ds_get_distincit_pallet_count(): Reports_custom_ds_get_distincit_pallet_countService {
    if(!this._custom_ds_get_distincit_pallet_count) {
      this._custom_ds_get_distincit_pallet_count = this.injector.get(Reports_custom_ds_get_distincit_pallet_countService);
    }
    return this._custom_ds_get_distincit_pallet_count;
  }
  private _custom_ds_get_first_warehouse: Reports_custom_ds_get_first_warehouseService;
  public get custom_ds_get_first_warehouse(): Reports_custom_ds_get_first_warehouseService {
    if(!this._custom_ds_get_first_warehouse) {
      this._custom_ds_get_first_warehouse = this.injector.get(Reports_custom_ds_get_first_warehouseService);
    }
    return this._custom_ds_get_first_warehouse;
  }
  private _custom_ds_get_first_warehouse_address_by_invoiceId: Reports_custom_ds_get_first_warehouse_address_by_invoiceIdService;
  public get custom_ds_get_first_warehouse_address_by_invoiceId(): Reports_custom_ds_get_first_warehouse_address_by_invoiceIdService {
    if(!this._custom_ds_get_first_warehouse_address_by_invoiceId) {
      this._custom_ds_get_first_warehouse_address_by_invoiceId = this.injector.get(Reports_custom_ds_get_first_warehouse_address_by_invoiceIdService);
    }
    return this._custom_ds_get_first_warehouse_address_by_invoiceId;
  }
  private _custom_ds_get_flow_order_data_blno_report: Reports_custom_ds_get_flow_order_data_blno_reportService;
  public get custom_ds_get_flow_order_data_blno_report(): Reports_custom_ds_get_flow_order_data_blno_reportService {
    if(!this._custom_ds_get_flow_order_data_blno_report) {
      this._custom_ds_get_flow_order_data_blno_report = this.injector.get(Reports_custom_ds_get_flow_order_data_blno_reportService);
    }
    return this._custom_ds_get_flow_order_data_blno_report;
  }
  private _custom_ds_get_flow_order_data_rnno_report: Reports_custom_ds_get_flow_order_data_rnno_reportService;
  public get custom_ds_get_flow_order_data_rnno_report(): Reports_custom_ds_get_flow_order_data_rnno_reportService {
    if(!this._custom_ds_get_flow_order_data_rnno_report) {
      this._custom_ds_get_flow_order_data_rnno_report = this.injector.get(Reports_custom_ds_get_flow_order_data_rnno_reportService);
    }
    return this._custom_ds_get_flow_order_data_rnno_report;
  }
  private _custom_ds_get_inbound_licenseplate_attachment: Reports_custom_ds_get_inbound_licenseplate_attachmentService;
  public get custom_ds_get_inbound_licenseplate_attachment(): Reports_custom_ds_get_inbound_licenseplate_attachmentService {
    if(!this._custom_ds_get_inbound_licenseplate_attachment) {
      this._custom_ds_get_inbound_licenseplate_attachment = this.injector.get(Reports_custom_ds_get_inbound_licenseplate_attachmentService);
    }
    return this._custom_ds_get_inbound_licenseplate_attachment;
  }
  private _custom_ds_get_inbound_lp_details: Reports_custom_ds_get_inbound_lp_detailsService;
  public get custom_ds_get_inbound_lp_details(): Reports_custom_ds_get_inbound_lp_detailsService {
    if(!this._custom_ds_get_inbound_lp_details) {
      this._custom_ds_get_inbound_lp_details = this.injector.get(Reports_custom_ds_get_inbound_lp_detailsService);
    }
    return this._custom_ds_get_inbound_lp_details;
  }
  private _custom_ds_get_inbound_lp_details_flow: Reports_custom_ds_get_inbound_lp_details_flowService;
  public get custom_ds_get_inbound_lp_details_flow(): Reports_custom_ds_get_inbound_lp_details_flowService {
    if(!this._custom_ds_get_inbound_lp_details_flow) {
      this._custom_ds_get_inbound_lp_details_flow = this.injector.get(Reports_custom_ds_get_inbound_lp_details_flowService);
    }
    return this._custom_ds_get_inbound_lp_details_flow;
  }
  private _custom_ds_get_invoice_header_by_invoiceId: Reports_custom_ds_get_invoice_header_by_invoiceIdService;
  public get custom_ds_get_invoice_header_by_invoiceId(): Reports_custom_ds_get_invoice_header_by_invoiceIdService {
    if(!this._custom_ds_get_invoice_header_by_invoiceId) {
      this._custom_ds_get_invoice_header_by_invoiceId = this.injector.get(Reports_custom_ds_get_invoice_header_by_invoiceIdService);
    }
    return this._custom_ds_get_invoice_header_by_invoiceId;
  }
  private _custom_ds_get_invoice_line_details_by_invoiceId_ne: Reports_custom_ds_get_invoice_line_details_by_invoiceId_neService;
  public get custom_ds_get_invoice_line_details_by_invoiceId_ne(): Reports_custom_ds_get_invoice_line_details_by_invoiceId_neService {
    if(!this._custom_ds_get_invoice_line_details_by_invoiceId_ne) {
      this._custom_ds_get_invoice_line_details_by_invoiceId_ne = this.injector.get(Reports_custom_ds_get_invoice_line_details_by_invoiceId_neService);
    }
    return this._custom_ds_get_invoice_line_details_by_invoiceId_ne;
  }
  private _custom_ds_get_invoice_lines_for_report_by_invoiceId: Reports_custom_ds_get_invoice_lines_for_report_by_invoiceIdService;
  public get custom_ds_get_invoice_lines_for_report_by_invoiceId(): Reports_custom_ds_get_invoice_lines_for_report_by_invoiceIdService {
    if(!this._custom_ds_get_invoice_lines_for_report_by_invoiceId) {
      this._custom_ds_get_invoice_lines_for_report_by_invoiceId = this.injector.get(Reports_custom_ds_get_invoice_lines_for_report_by_invoiceIdService);
    }
    return this._custom_ds_get_invoice_lines_for_report_by_invoiceId;
  }
  private _custom_ds_get_lp_contents: Reports_custom_ds_get_lp_contentsService;
  public get custom_ds_get_lp_contents(): Reports_custom_ds_get_lp_contentsService {
    if(!this._custom_ds_get_lp_contents) {
      this._custom_ds_get_lp_contents = this.injector.get(Reports_custom_ds_get_lp_contentsService);
    }
    return this._custom_ds_get_lp_contents;
  }
  private _custom_ds_get_material_packaging_weight: Reports_custom_ds_get_material_packaging_weightService;
  public get custom_ds_get_material_packaging_weight(): Reports_custom_ds_get_material_packaging_weightService {
    if(!this._custom_ds_get_material_packaging_weight) {
      this._custom_ds_get_material_packaging_weight = this.injector.get(Reports_custom_ds_get_material_packaging_weightService);
    }
    return this._custom_ds_get_material_packaging_weight;
  }
  private _custom_ds_get_order_by_order_id_rpt: Reports_custom_ds_get_order_by_order_id_rptService;
  public get custom_ds_get_order_by_order_id_rpt(): Reports_custom_ds_get_order_by_order_id_rptService {
    if(!this._custom_ds_get_order_by_order_id_rpt) {
      this._custom_ds_get_order_by_order_id_rpt = this.injector.get(Reports_custom_ds_get_order_by_order_id_rptService);
    }
    return this._custom_ds_get_order_by_order_id_rpt;
  }
  private _custom_ds_get_order_data_blno_report: Reports_custom_ds_get_order_data_blno_reportService;
  public get custom_ds_get_order_data_blno_report(): Reports_custom_ds_get_order_data_blno_reportService {
    if(!this._custom_ds_get_order_data_blno_report) {
      this._custom_ds_get_order_data_blno_report = this.injector.get(Reports_custom_ds_get_order_data_blno_reportService);
    }
    return this._custom_ds_get_order_data_blno_report;
  }
  private _custom_ds_get_order_data_rnno_report: Reports_custom_ds_get_order_data_rnno_reportService;
  public get custom_ds_get_order_data_rnno_report(): Reports_custom_ds_get_order_data_rnno_reportService {
    if(!this._custom_ds_get_order_data_rnno_report) {
      this._custom_ds_get_order_data_rnno_report = this.injector.get(Reports_custom_ds_get_order_data_rnno_reportService);
    }
    return this._custom_ds_get_order_data_rnno_report;
  }
  private _custom_ds_get_order_signature_attachment: Reports_custom_ds_get_order_signature_attachmentService;
  public get custom_ds_get_order_signature_attachment(): Reports_custom_ds_get_order_signature_attachmentService {
    if(!this._custom_ds_get_order_signature_attachment) {
      this._custom_ds_get_order_signature_attachment = this.injector.get(Reports_custom_ds_get_order_signature_attachmentService);
    }
    return this._custom_ds_get_order_signature_attachment;
  }
  private _custom_ds_get_outbound_first_load_survey_advanced: Reports_custom_ds_get_outbound_first_load_survey_advancedService;
  public get custom_ds_get_outbound_first_load_survey_advanced(): Reports_custom_ds_get_outbound_first_load_survey_advancedService {
    if(!this._custom_ds_get_outbound_first_load_survey_advanced) {
      this._custom_ds_get_outbound_first_load_survey_advanced = this.injector.get(Reports_custom_ds_get_outbound_first_load_survey_advancedService);
    }
    return this._custom_ds_get_outbound_first_load_survey_advanced;
  }
  private _custom_ds_get_outbound_last_load_survey_advanced: Reports_custom_ds_get_outbound_last_load_survey_advancedService;
  public get custom_ds_get_outbound_last_load_survey_advanced(): Reports_custom_ds_get_outbound_last_load_survey_advancedService {
    if(!this._custom_ds_get_outbound_last_load_survey_advanced) {
      this._custom_ds_get_outbound_last_load_survey_advanced = this.injector.get(Reports_custom_ds_get_outbound_last_load_survey_advancedService);
    }
    return this._custom_ds_get_outbound_last_load_survey_advanced;
  }
  private _custom_ds_get_outbound_licenseplate_attachment: Reports_custom_ds_get_outbound_licenseplate_attachmentService;
  public get custom_ds_get_outbound_licenseplate_attachment(): Reports_custom_ds_get_outbound_licenseplate_attachmentService {
    if(!this._custom_ds_get_outbound_licenseplate_attachment) {
      this._custom_ds_get_outbound_licenseplate_attachment = this.injector.get(Reports_custom_ds_get_outbound_licenseplate_attachmentService);
    }
    return this._custom_ds_get_outbound_licenseplate_attachment;
  }
  private _custom_ds_get_owner_address_by_invoiceId: Reports_custom_ds_get_owner_address_by_invoiceIdService;
  public get custom_ds_get_owner_address_by_invoiceId(): Reports_custom_ds_get_owner_address_by_invoiceIdService {
    if(!this._custom_ds_get_owner_address_by_invoiceId) {
      this._custom_ds_get_owner_address_by_invoiceId = this.injector.get(Reports_custom_ds_get_owner_address_by_invoiceIdService);
    }
    return this._custom_ds_get_owner_address_by_invoiceId;
  }
  private _custom_ds_get_pallet_details: Reports_custom_ds_get_pallet_detailsService;
  public get custom_ds_get_pallet_details(): Reports_custom_ds_get_pallet_detailsService {
    if(!this._custom_ds_get_pallet_details) {
      this._custom_ds_get_pallet_details = this.injector.get(Reports_custom_ds_get_pallet_detailsService);
    }
    return this._custom_ds_get_pallet_details;
  }
  private _custom_ds_get_shipping_pallets_by_order_id: Reports_custom_ds_get_shipping_pallets_by_order_idService;
  public get custom_ds_get_shipping_pallets_by_order_id(): Reports_custom_ds_get_shipping_pallets_by_order_idService {
    if(!this._custom_ds_get_shipping_pallets_by_order_id) {
      this._custom_ds_get_shipping_pallets_by_order_id = this.injector.get(Reports_custom_ds_get_shipping_pallets_by_order_idService);
    }
    return this._custom_ds_get_shipping_pallets_by_order_id;
  }
  private _custom_ds_get_survey_by_loadcontainer_rpt: Reports_custom_ds_get_survey_by_loadcontainer_rptService;
  public get custom_ds_get_survey_by_loadcontainer_rpt(): Reports_custom_ds_get_survey_by_loadcontainer_rptService {
    if(!this._custom_ds_get_survey_by_loadcontainer_rpt) {
      this._custom_ds_get_survey_by_loadcontainer_rpt = this.injector.get(Reports_custom_ds_get_survey_by_loadcontainer_rptService);
    }
    return this._custom_ds_get_survey_by_loadcontainer_rpt;
  }
  private _custom_ds_get_surveyoperationcontexttypes_by_name_rpt: Reports_custom_ds_get_surveyoperationcontexttypes_by_name_rptService;
  public get custom_ds_get_surveyoperationcontexttypes_by_name_rpt(): Reports_custom_ds_get_surveyoperationcontexttypes_by_name_rptService {
    if(!this._custom_ds_get_surveyoperationcontexttypes_by_name_rpt) {
      this._custom_ds_get_surveyoperationcontexttypes_by_name_rpt = this.injector.get(Reports_custom_ds_get_surveyoperationcontexttypes_by_name_rptService);
    }
    return this._custom_ds_get_surveyoperationcontexttypes_by_name_rpt;
  }
  private _custom_ds_get_warehouse_address_by_warehouseId: Reports_custom_ds_get_warehouse_address_by_warehouseIdService;
  public get custom_ds_get_warehouse_address_by_warehouseId(): Reports_custom_ds_get_warehouse_address_by_warehouseIdService {
    if(!this._custom_ds_get_warehouse_address_by_warehouseId) {
      this._custom_ds_get_warehouse_address_by_warehouseId = this.injector.get(Reports_custom_ds_get_warehouse_address_by_warehouseIdService);
    }
    return this._custom_ds_get_warehouse_address_by_warehouseId;
  }
  private _custom_ds_inbound_order_audit_report_header: Reports_custom_ds_inbound_order_audit_report_headerService;
  public get custom_ds_inbound_order_audit_report_header(): Reports_custom_ds_inbound_order_audit_report_headerService {
    if(!this._custom_ds_inbound_order_audit_report_header) {
      this._custom_ds_inbound_order_audit_report_header = this.injector.get(Reports_custom_ds_inbound_order_audit_report_headerService);
    }
    return this._custom_ds_inbound_order_audit_report_header;
  }
  private _custom_ds_inbound_order_details_report: Reports_custom_ds_inbound_order_details_reportService;
  public get custom_ds_inbound_order_details_report(): Reports_custom_ds_inbound_order_details_reportService {
    if(!this._custom_ds_inbound_order_details_report) {
      this._custom_ds_inbound_order_details_report = this.injector.get(Reports_custom_ds_inbound_order_details_reportService);
    }
    return this._custom_ds_inbound_order_details_report;
  }
  private _custom_ds_inbound_order_details_report_auto_email: Reports_custom_ds_inbound_order_details_report_auto_emailService;
  public get custom_ds_inbound_order_details_report_auto_email(): Reports_custom_ds_inbound_order_details_report_auto_emailService {
    if(!this._custom_ds_inbound_order_details_report_auto_email) {
      this._custom_ds_inbound_order_details_report_auto_email = this.injector.get(Reports_custom_ds_inbound_order_details_report_auto_emailService);
    }
    return this._custom_ds_inbound_order_details_report_auto_email;
  }
  private _custom_ds_inbound_order_summary_report: Reports_custom_ds_inbound_order_summary_reportService;
  public get custom_ds_inbound_order_summary_report(): Reports_custom_ds_inbound_order_summary_reportService {
    if(!this._custom_ds_inbound_order_summary_report) {
      this._custom_ds_inbound_order_summary_report = this.injector.get(Reports_custom_ds_inbound_order_summary_reportService);
    }
    return this._custom_ds_inbound_order_summary_report;
  }
  private _custom_ds_inbound_order_summary_report_auto_email: Reports_custom_ds_inbound_order_summary_report_auto_emailService;
  public get custom_ds_inbound_order_summary_report_auto_email(): Reports_custom_ds_inbound_order_summary_report_auto_emailService {
    if(!this._custom_ds_inbound_order_summary_report_auto_email) {
      this._custom_ds_inbound_order_summary_report_auto_email = this.injector.get(Reports_custom_ds_inbound_order_summary_report_auto_emailService);
    }
    return this._custom_ds_inbound_order_summary_report_auto_email;
  }
  private _custom_ds_inventory_by_license_plate_data: Reports_custom_ds_inventory_by_license_plate_dataService;
  public get custom_ds_inventory_by_license_plate_data(): Reports_custom_ds_inventory_by_license_plate_dataService {
    if(!this._custom_ds_inventory_by_license_plate_data) {
      this._custom_ds_inventory_by_license_plate_data = this.injector.get(Reports_custom_ds_inventory_by_license_plate_dataService);
    }
    return this._custom_ds_inventory_by_license_plate_data;
  }
  private _custom_ds_inventory_by_license_plate_report: Reports_custom_ds_inventory_by_license_plate_reportService;
  public get custom_ds_inventory_by_license_plate_report(): Reports_custom_ds_inventory_by_license_plate_reportService {
    if(!this._custom_ds_inventory_by_license_plate_report) {
      this._custom_ds_inventory_by_license_plate_report = this.injector.get(Reports_custom_ds_inventory_by_license_plate_reportService);
    }
    return this._custom_ds_inventory_by_license_plate_report;
  }
  private _custom_ds_inventory_count_tasks: Reports_custom_ds_inventory_count_tasksService;
  public get custom_ds_inventory_count_tasks(): Reports_custom_ds_inventory_count_tasksService {
    if(!this._custom_ds_inventory_count_tasks) {
      this._custom_ds_inventory_count_tasks = this.injector.get(Reports_custom_ds_inventory_count_tasksService);
    }
    return this._custom_ds_inventory_count_tasks;
  }
  private _custom_ds_inventory_detail: Reports_custom_ds_inventory_detailService;
  public get custom_ds_inventory_detail(): Reports_custom_ds_inventory_detailService {
    if(!this._custom_ds_inventory_detail) {
      this._custom_ds_inventory_detail = this.injector.get(Reports_custom_ds_inventory_detailService);
    }
    return this._custom_ds_inventory_detail;
  }
  private _custom_ds_inventory_detail_data: Reports_custom_ds_inventory_detail_dataService;
  public get custom_ds_inventory_detail_data(): Reports_custom_ds_inventory_detail_dataService {
    if(!this._custom_ds_inventory_detail_data) {
      this._custom_ds_inventory_detail_data = this.injector.get(Reports_custom_ds_inventory_detail_dataService);
    }
    return this._custom_ds_inventory_detail_data;
  }
  private _custom_ds_inventory_detail_report: Reports_custom_ds_inventory_detail_reportService;
  public get custom_ds_inventory_detail_report(): Reports_custom_ds_inventory_detail_reportService {
    if(!this._custom_ds_inventory_detail_report) {
      this._custom_ds_inventory_detail_report = this.injector.get(Reports_custom_ds_inventory_detail_reportService);
    }
    return this._custom_ds_inventory_detail_report;
  }
  private _custom_ds_obol_getlicenseplates_orderid_report: Reports_custom_ds_obol_getlicenseplates_orderid_reportService;
  public get custom_ds_obol_getlicenseplates_orderid_report(): Reports_custom_ds_obol_getlicenseplates_orderid_reportService {
    if(!this._custom_ds_obol_getlicenseplates_orderid_report) {
      this._custom_ds_obol_getlicenseplates_orderid_report = this.injector.get(Reports_custom_ds_obol_getlicenseplates_orderid_reportService);
    }
    return this._custom_ds_obol_getlicenseplates_orderid_report;
  }
  private _custom_ds_outbound_details_bill_of_lading_report_advanced: Reports_custom_ds_outbound_details_bill_of_lading_report_advancedService;
  public get custom_ds_outbound_details_bill_of_lading_report_advanced(): Reports_custom_ds_outbound_details_bill_of_lading_report_advancedService {
    if(!this._custom_ds_outbound_details_bill_of_lading_report_advanced) {
      this._custom_ds_outbound_details_bill_of_lading_report_advanced = this.injector.get(Reports_custom_ds_outbound_details_bill_of_lading_report_advancedService);
    }
    return this._custom_ds_outbound_details_bill_of_lading_report_advanced;
  }
  private _custom_ds_outbound_header_bill_of_lading_report: Reports_custom_ds_outbound_header_bill_of_lading_reportService;
  public get custom_ds_outbound_header_bill_of_lading_report(): Reports_custom_ds_outbound_header_bill_of_lading_reportService {
    if(!this._custom_ds_outbound_header_bill_of_lading_report) {
      this._custom_ds_outbound_header_bill_of_lading_report = this.injector.get(Reports_custom_ds_outbound_header_bill_of_lading_reportService);
    }
    return this._custom_ds_outbound_header_bill_of_lading_report;
  }
  private _custom_ds_outbound_order_audit_report_header: Reports_custom_ds_outbound_order_audit_report_headerService;
  public get custom_ds_outbound_order_audit_report_header(): Reports_custom_ds_outbound_order_audit_report_headerService {
    if(!this._custom_ds_outbound_order_audit_report_header) {
      this._custom_ds_outbound_order_audit_report_header = this.injector.get(Reports_custom_ds_outbound_order_audit_report_headerService);
    }
    return this._custom_ds_outbound_order_audit_report_header;
  }
  private _custom_ds_outbound_order_details_report: Reports_custom_ds_outbound_order_details_reportService;
  public get custom_ds_outbound_order_details_report(): Reports_custom_ds_outbound_order_details_reportService {
    if(!this._custom_ds_outbound_order_details_report) {
      this._custom_ds_outbound_order_details_report = this.injector.get(Reports_custom_ds_outbound_order_details_reportService);
    }
    return this._custom_ds_outbound_order_details_report;
  }
  private _custom_ds_outbound_order_details_report_auto_email: Reports_custom_ds_outbound_order_details_report_auto_emailService;
  public get custom_ds_outbound_order_details_report_auto_email(): Reports_custom_ds_outbound_order_details_report_auto_emailService {
    if(!this._custom_ds_outbound_order_details_report_auto_email) {
      this._custom_ds_outbound_order_details_report_auto_email = this.injector.get(Reports_custom_ds_outbound_order_details_report_auto_emailService);
    }
    return this._custom_ds_outbound_order_details_report_auto_email;
  }
  private _custom_ds_outbound_order_summary_report: Reports_custom_ds_outbound_order_summary_reportService;
  public get custom_ds_outbound_order_summary_report(): Reports_custom_ds_outbound_order_summary_reportService {
    if(!this._custom_ds_outbound_order_summary_report) {
      this._custom_ds_outbound_order_summary_report = this.injector.get(Reports_custom_ds_outbound_order_summary_reportService);
    }
    return this._custom_ds_outbound_order_summary_report;
  }
  private _custom_ds_outbound_shipment_summary_report_auto_email: Reports_custom_ds_outbound_shipment_summary_report_auto_emailService;
  public get custom_ds_outbound_shipment_summary_report_auto_email(): Reports_custom_ds_outbound_shipment_summary_report_auto_emailService {
    if(!this._custom_ds_outbound_shipment_summary_report_auto_email) {
      this._custom_ds_outbound_shipment_summary_report_auto_email = this.injector.get(Reports_custom_ds_outbound_shipment_summary_report_auto_emailService);
    }
    return this._custom_ds_outbound_shipment_summary_report_auto_email;
  }
  private _custom_ds_pallet_transactions_details: Reports_custom_ds_pallet_transactions_detailsService;
  public get custom_ds_pallet_transactions_details(): Reports_custom_ds_pallet_transactions_detailsService {
    if(!this._custom_ds_pallet_transactions_details) {
      this._custom_ds_pallet_transactions_details = this.injector.get(Reports_custom_ds_pallet_transactions_detailsService);
    }
    return this._custom_ds_pallet_transactions_details;
  }
  private _ds_get_licenseplates_by_inbound_orderId: Reports_ds_get_licenseplates_by_inbound_orderIdService;
  public get ds_get_licenseplates_by_inbound_orderId(): Reports_ds_get_licenseplates_by_inbound_orderIdService {
    if(!this._ds_get_licenseplates_by_inbound_orderId) {
      this._ds_get_licenseplates_by_inbound_orderId = this.injector.get(Reports_ds_get_licenseplates_by_inbound_orderIdService);
    }
    return this._ds_get_licenseplates_by_inbound_orderId;
  }
  private _ds_get_licenseplates_by_shipmentId: Reports_ds_get_licenseplates_by_shipmentIdService;
  public get ds_get_licenseplates_by_shipmentId(): Reports_ds_get_licenseplates_by_shipmentIdService {
    if(!this._ds_get_licenseplates_by_shipmentId) {
      this._ds_get_licenseplates_by_shipmentId = this.injector.get(Reports_ds_get_licenseplates_by_shipmentIdService);
    }
    return this._ds_get_licenseplates_by_shipmentId;
  }
  private _ds_get_order_signature_attachment: Reports_ds_get_order_signature_attachmentService;
  public get ds_get_order_signature_attachment(): Reports_ds_get_order_signature_attachmentService {
    if(!this._ds_get_order_signature_attachment) {
      this._ds_get_order_signature_attachment = this.injector.get(Reports_ds_get_order_signature_attachmentService);
    }
    return this._ds_get_order_signature_attachment;
  }
  private _ds_get_shipment_by_orderId_top1: Reports_ds_get_shipment_by_orderId_top1Service;
  public get ds_get_shipment_by_orderId_top1(): Reports_ds_get_shipment_by_orderId_top1Service {
    if(!this._ds_get_shipment_by_orderId_top1) {
      this._ds_get_shipment_by_orderId_top1 = this.injector.get(Reports_ds_get_shipment_by_orderId_top1Service);
    }
    return this._ds_get_shipment_by_orderId_top1;
  }
}

